// import { getBrowserLocale, /* isLocaleListed */ } from 'locales/utils'
import { GET_NOTIFICATIONS_SUCCESS, SET_NOTIFICATION_READ } from '../actions/actionTypes'

const initialState = {
  list: [],
  unread: 0
}

const notifications = (state = initialState, action) => {
  switch (action.type) {
    case GET_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        list: action.list,
        unread: action.unread
      }
    case SET_NOTIFICATION_READ:
      return {
        ...state,
        list: state.list.map((notice) => {
          if (notice.id === action.id) {
            notice.state = 'read'
          }

          return notice
        }),
        unread: state.unread - 1
      }
    default:
      return state
  }
}

export default notifications
